/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BoostTier2Icon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABP0lEQVR4nO1VPUoDURDeyhNYBC1UvIIHsE4yPwSeM1pYegQlVezEI+QQak6QSjyFCMHCWtAIBozM27fJYzWwa3ZDCgcG3s7Mft/7/SZJ1sWI5BBZn8xtXCk4sJwBySeyToNPgORiaWDn3Aay9gPoF5Bemds4xPpW8yfwdvt4E1iHHojkA/HoNMsRiSDre5rT+6ZzjVLgzLKPrCMDAJJnRD3I11jM59KVjJqdk53CBEh6E2b+EM/O9h1Yu9m35awmJZG7MgQv/ifUrQj8cn7Icp3FWy23HWJvxQkC0AyctRvdIO/xSvL15QlIxz8ISMeVEWAOfFH+n2Ba5xZNaj1kqOGaep2xRzQjIT2PCHq/PLTX4gSkg4VSQXOZjqUCWG4LExDJblmxA3B7ydrI9UoazkpaZhKZNXogfTSvvOkvY99mtlr0LlnqdwAAAABJRU5ErkJggg==)
 */
export const BoostTier2Icon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M11.65 6.35 9.29 8.71a1 1 0 0 0-.29.7v5.18c0 .26.1.52.3.7l2.35 2.36c.2.2.5.2.7 0l2.36-2.36a1 1 0 0 0 .29-.7V9.4a1 1 0 0 0-.3-.7l-2.35-2.36a.5.5 0 0 0-.7 0Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M10.95 1.4a1.59 1.59 0 0 1 2.1 0l4.9 4A3.37 3.37 0 0 1 19 8v8c0 1.07-.4 2.06-1.05 2.6l-4.9 4c-.65.53-1.45.53-2.1 0l-4.9-4A3.37 3.37 0 0 1 5 16V8c0-1.07.4-2.06 1.05-2.6l4.9-4ZM7.32 6.95 12 3.12l4.68 3.83c.07.06.32.4.32 1.05v8c0 .65-.25 1-.32 1.05L12 20.88l-4.68-3.83C7.25 16.99 7 16.65 7 16V8c0-.65.25-1 .32-1.05Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
